<template>
	<div v-show="searchVisible" class="general-search form-container">

		<div class="general-search-overlay" @click.self="close">

			<div :class="[searchVisible ? 'general-search-container-visible' : '', 'general-search-container']">
				<div class="general-search-dropdown">

					<icon v-show="!loading" icon="search" group="light" class="general-search-icon" />

					<svg v-show="loading" class="spinner" viewBox="0 0 50 50">
						<circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
					</svg>

					<nk-input :disabled="disabled" v-model="displayText" @update:modelValue="displayTextChanged" :options="componentOptions.input" :tabindex="disabled ? null : tabindex" startup ref="input" class="general-search-input"></nk-input>
					<icon v-show="displayText.length" @click="clearSelection" icon="times" class="general-search-icon" group="light" style="cursor: pointer" />

				</div>

				<div class="general-search-result">

					<div v-if="!searchResult.length && enterPressed" class="general-search-result-no-data general-search-result-detail-row">
						{{ $t('grid.nodata') }}
					</div>

					<div class="general-search-result-group d-flex flex-column" v-for="(groupedBySystem, system, index) in GroupBy(searchResult, (x) => x.module)" :key="index">
						<span class="general-search-result-system-title">{{ $t(`enum-items.NikanSystems.${system}`) }}</span>
						<div class="general-search-result-type-title" v-for="(groupedByEntityTypes, entityType, index) in GroupBy(groupedBySystem, (x) => x.entityType)" :key="index">
							<span>{{ $t(`general-search.entityTypes.${entityType}`) }}</span>
							<div class="general-search-result-detail-row" @click="rowClicked(row)" v-for="(row, index) in groupedByEntityTypes" :key="index">

								<div class="general-search-result-detail-title-container">
									<div v-if="row.entityType === 'DocumentDetail' || row.entityType === 'DocumentHeader'" class="general-search-result-detail-row-chevron" @click.stop="loadExtraDetail(row)">
										<svg v-if="row.isLoading" class="spinner" viewBox="0 0 50 50">
											<circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
										</svg>
										<icon v-else :class="{ 'rotate-90': row.isExpanded }" icon="chevron-left" />
									</div>
									<span>{{ row.title }}</span>
								</div>

								<div :class="{ 'detail-expanded': row.isExpanded }" @click.stop="" class="general-search-result-detail">
									<DocumentPreviewMinimal v-if="(row.entityType === 'DocumentDetail' || row.entityType === 'DocumentHeader') && row?.document" :data="row.document" :detailId="row.entityId" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>

	import { findRoute } from '~/statics/routes'
	import Endpoints from '@nikan/endpoints'
	import { post } from '~/plugins/nikan-api'
	import Merge from 'lodash/merge'
	import GroupBy from 'lodash/groupBy'
	import CloneDeep from 'lodash/cloneDeep'
	import $sc from "@/plugins/shortcut.collection"
	import maxBy from 'lodash/maxBy'
	import DocumentPreviewMinimal from '../minimal-preview/document-preview-minimal.vue'
	export default {
		name: 'general-search-dropdown',
		props: {
			options: {},
			disabled: { type: Boolean, default: false },
			tabindex: { type: [String, Number], default: 100 },
		},
		watch: {
			options: {
				deep: true,
				immediate: true,
				handler(val) {
					this.settings = Merge(this.settings, val)
				},
			},
		},
		components: {
			DocumentPreviewMinimal
		},
		data() {
			return {
				displayText: '',
				enterPressed: false,
				selectorVisble: false,
				searchVisible: false,
				oldFocusedElement: null,
				loading: false,
				searchResult: [],
				settings: {},
				cacheData: {},
				componentOptions: {
					input: {
						placeholder: `${this.$t('search-it')}...`,
					},
				},
			}
		},
		methods: {
			maxBy,
			GroupBy,
			close() {
				this.cacheData = {}
				this.searchVisible = false
				this.clearSelection()
				this.focus()
			},
			open() {
				this.searchVisible = true
				this.focus()
			},
			focus() {
				this.defer(() => {
					const input = this.$refs.input.$el

					if (this.searchVisible && document.activeElement !== input) {
						this.oldFocusedElement = document.activeElement
						input.focus()
					}
					else {
						this.oldFocusedElement.focus()
					}

				}, 100)
			},
			toggle() {
				if (this.searchVisible)
					this.close()
				else
					this.open()
			},
			displayTextChanged(val) {
				if (!val || !val.length)
					this.clearSelection()
			},
			rowClicked(val) {
				const route = findRoute('profile')

				let entityType
				let entityId
				let data

				switch (val.entityType) {
					case 'DocumentDetail':
						entityType = 'DocumentHeader'
						entityId = val.data.documentId
						data = { entityId: val.data.documentId, entityType: 'DocumentHeader' }
						break

					default:
						entityId = val.entityId
						entityType = val.entityType
						data = val
						break
				}

				if (route) {
					route.data = data
					route.query = {
						entityType: entityType,
						entityId: entityId,
					}
					this.$openTab(route)
					this.close()
				}
				else
					throw Error('General Search Route Not Found!')
			},
			clearSelection() {
				this.searchResult = []
				this.displayText = ''
				this.enterPressed = false
			},
			validateInputs(searchKeyword) {

				if (!searchKeyword || !searchKeyword.length)
					return false

				return true
			},
			loadDocument(row, isDetail = false) {
				return new Promise((resolve, reject) => {
					const docId = isDetail ? row.data.documentId : row.entityId

					if (this.cacheData[docId]) {
						row.isExpanded = true
						row.document = this.cacheData[docId]
						resolve()
						return
					}

					post(Endpoints.getUrl('documents.get'), { id: docId }, null, { silent: true })
						.then((result) => {
							row.isExpanded = true

							const documentData = result.data

							this.cacheData[docId] = documentData

							row.document = documentData
							resolve()
						}).catch(() => {
							reject()
						})
				})

			},
			loadExtraDetail(row) {
				if (row.isExpanded) {
					row.isExpanded = false
					return
				}

				row.isLoading = true
				switch (row.entityType) {
					case 'DocumentDetail':
						this.loadDocument(row, true).finally(() => {
							row.isLoading = false
						})
						break
					case 'DocumentHeader':
						this.loadDocument(row).finally(() => {
							row.isLoading = false
						})
						break
				}
			},
			search() {

				const searchKeyword = this.displayText.trim()

				if (!this.validateInputs(searchKeyword))
					return

				this.loading = true
				const url = Endpoints.getUrl('general-search.list')
				const requestData = {
					searchType: 0,
					keyword: searchKeyword
				}
				post(url, requestData)
					.then(res => {
						this.searchResult = res.data
					})
					.finally(() => {
						this.enterPressed = true
						this.loading = false
					})

			},
			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: 'search',
					keyCode: 13, // 13:enter
					el: this.$refs.input.$el,
					context: this,
					handler: function (sender, e) {

						if (e.ctrlKey || this.disabled)
							return

						e.preventDefault()

						this.search()
						return true
					},
				})
				this.$keyHandler.Subscribe({
					name: 'close',
					shortcut: $sc.find('exit'),
					el: this.$el,
					context: this,
					handler: function (sender, e) {

						if (e.ctrlKey || this.disabled)
							return

						e.preventDefault()

						this.close()
						return true
					},
				})
			}
		},
	}
</script>

<style lang="less">
	@import "~/styles/general-search.less";
</style>